import axios from 'axios'
const baseURL = '/back-office'
export default class ApiManagerBoCutomer {
    static update(params) {
        return axios
            .put(`${baseURL}/v2/model_template/createOrUpdate`, params)
            .then((res) => {
                return res.data
            })
            .catch((error) => {
                console.error('Error fetching customers:', error)
                throw error
            })
    }
}
